/* eslint-disable react-hooks/exhaustive-deps */
import './index.css'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import actionTypes from 'store/actions'
import { Box } from '@mui/system'
import Alert from '@mui/material/Alert'
import VaultIcon from 'assets/vault icons/vaulticon.svg'
import FormInput from 'components/Common/FormInput'
import { VaultAPI } from 'api'
import routes from 'routes'
import MainLayout from 'layouts/mainLayout'
import { Link, Typography } from '@mui/material'
import { store } from 'reduxStore'
import CheckCircle from '@mui/icons-material/CheckCircleOutline';
import ErrorIcon from '@mui/icons-material/Error';
import Button from 'components/Common/Button'
import { PRIMARY_BUTTON, DISABLED_BUTTON } from 'themes/theme'


const VaultVerification = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const vaultInfo = useSelector(state => state.apiResponseReducers.dashboardInfo.vault_info)
  const isVerifying = useSelector(state => state.vaultReducer.isVerifying)
  const accessCodeVerified = useSelector(state => state.vaultReducer.accessCodeVerified)
  const [timer, setTimer] = useState(0)
  const [isFirstTime, setIsFirstTime] = useState(true)
  const user = store.getState().userReducer.user

  const userInfo = useSelector(state => state.userReducer.user)

  const toWelcome = () => {
    navigate('/welcome')
  }

  const [verificationCode, setVerificationCode] = useState('')
  const [errorMsg, setErrorMsg] = useState("")
  const [blockerror, setBlockError] = useState(false)
  const [isCodeSent, setIsCodeSent] = useState(false)
  const [resendError, setResendError] = useState(false)

  useEffect(() => {
    if (user?.accountType === 'premium') {
      VaultAPI.sendVerificationCode(vaultInfo?.vault_id)
    }
  }, [])

  useEffect(() => {
    if (accessCodeVerified) {
      setTimeout(() => {
        navigate(routes.vault)
        dispatch({ type: actionTypes.VAULTVERITYRESET })
        setIsCodeSent(false);
      }, 3000)
    }
  }, [accessCodeVerified])

  useEffect(() => {
    let interval = null
    if (timer === 0) {
      if (interval) clearInterval(interval)
    } else {
      interval = setInterval(() => {
        setTimer(timer => timer - 1)
      }, 1000)
    }

    return () => clearInterval(interval)
  }, [timer])

  const onSendVerificationCode = async () => {
    //TODO: Send verification code
    setIsFirstTime(true);
    if (user?.accountType === 'premium') {
      await VaultAPI.sendVerificationCode(vaultInfo?.vault_id).catch((err) =>{
          if (err.response.data.errors === "This vault is not accessible or does not exist"){
            setResendError(true)
            setIsCodeSent(false)
          } else {
            setResendError(false)
          }
      })
      setIsCodeSent(true);
    }
  }

  const reset = () => {
    dispatch({ type: actionTypes.VAULTVERITYRESET });
  }

  const onVerify = () => {
    setIsFirstTime(false);
    setIsCodeSent(false);
    VaultAPI.otpVerify(dispatch, vaultInfo?.vault_id, verificationCode)
    .catch(err=>{
      if (err.response.data.details === "Invalid"){
        setErrorMsg("Invalid code entered!")
      }
      else if(err.response.data.errors === "The user is blocked because of maximum retry attempts" || err.response.data.errors === "This vault is not accessible or does not exist"){
        setBlockError(true)
      }
    })
  }

  if (userInfo?.accountType === 'free') {
    return (
      <MainLayout>
        <Box textAlign="center" marginTop={10}>
          <div className="vault">
            <img src={VaultIcon} alt="VaultIcon" sx={{ width: '60px', height: '60px' }} />
            <Typography variant="h4" className="mt-5 color-primary">
              Manage Vault
            </Typography>
            <Typography className="mt-5" variant="Body1" sx={{ width: '60%', textAlign: 'center', lineHeight: '21px', fontSize: '14px', color: '#66668F' }}>
              The Vault is a secure place to upload, organize, store, and share key documents. This saves<br />
              you the time and the hassle of locating and sharing your sensitive and critical business data<br />
              when qualifying for a loan, line of credit, insurance, rental space, and more.
            </Typography>
            <Typography variant="h6" sx={{ color: '#0A78CD', marginTop: '40px', fontWeight: 600 }}>
              Become a premium member to enter Vault
            </Typography>
            <Button sx={{marginTop: "35px", width:"250px"}} onClick={toWelcome}>
              {'Upgrade'}
            </Button>
          </div>
        </Box>
      </MainLayout>
    )
  }

  return (
    <MainLayout>
      <Box textAlign="center" marginTop={10}>
        <div className="vault">
          <img src={VaultIcon} alt="VaultIcon" sx={{ width: '60px', height: '60px' }} />
          <Typography variant="h4" className="mt-5 color-primary">
            Manage Vault
          </Typography>
          <span className="mt-5" variant="body1" style={{ width: '40%', fontSize: '16px', color: '#25245f', fontFamily: 'poppins', fontWeight: 400 }}>
            To access your vault, please enter a verification code <br />
            sent to your registered email.
          </span>
          <FormInput
            type="number"
            // style={{ fontSize: '15px', height: '50px', width: '325px' }}
            className="verification-input mt-5"
            bgwhite
            onWheel={e => e.target.blur()}
            onKeyDown={e => {
              if (e.keyCode === 38 || e.keyCode === 40) return e.preventDefault()
            }}
            onChange={(id, value) => setVerificationCode(value)}
            validator={value => value && value.length}
            value={verificationCode}
          />
          <Button
            onClick={onVerify}
            style={{ width: '250px', marginTop: '50px' }}
            loading={isVerifying}
            type={
              verificationCode.length === 6 || isVerifying || accessCodeVerified
                ? PRIMARY_BUTTON
                : DISABLED_BUTTON
            }
          >
            Submit
          </Button>
          <Link
            onClick={onSendVerificationCode}
            underline="hover"
            sx={{
              color: '#0A78CD',
              marginTop: '20px',
              fontWeight: '700',
              fontSize: '12px',
              fontFamily: 'poppins',
              textTransform: 'capitalize',
              textDecoration: 'none',
              cursor: 'pointer',
            }}
          >
            {'Resend Code'}
          </Link>
          {isCodeSent && !resendError && (
            <Alert role="alert" sx={{marginTop: "2%"}} onClose={() => setIsCodeSent(false)} severity="success">
              A code has been resent to <span className="text-bold">{userInfo.email}</span>
            </Alert>
          )}
          { resendError && <Alert sx={{marginTop: "2%"}} role="alert" iconMapping={{
              error: <ErrorIcon fontSize="inherit" />,
            }} severity="error">
              <Box textAlign="left" marginTop="5px">
              Invalid code entered 3 times. Your Vault is now locked.
              <p>Please contact&nbsp;<Link href="https://share.hsforms.com/1n5-LEIiqTUyScicS-czMBAcdn4z" rel="noreferrer"
                target="_blank"
                fontWeight="bold"
                color="#D14343 !important"
                textDecoration="underline"
                sx={{ textDecorationColor: '#D14343 !important' }}>customer support</Link>&nbsp;for help.</p>
              </Box>
              </Alert>
          }

          {!isVerifying && accessCodeVerified && !isFirstTime && (
            <Alert sx={{marginTop: "2%"}} role="alert" onClose={() => reset} iconMapping={{
              success: <CheckCircle fontSize="inherit" />,
            }}
              color="success" severity="success">You are being redirected to the vault...</Alert>
          )}
          {!isVerifying && !accessCodeVerified && !isFirstTime
            && !blockerror && <Alert sx={{marginTop: "2%"}} role="alert" iconMapping={{
              error: <ErrorIcon fontSize="inherit" />,
            }} severity="error" onClose={() => setIsFirstTime(true)}>{errorMsg}</Alert>}

            {!isVerifying && !accessCodeVerified && !isFirstTime && blockerror && 
             <Alert sx={{marginTop: "2%"}} role="alert" iconMapping={{
              error: <ErrorIcon fontSize="inherit" />,
            }} severity="error">
              <Box textAlign="left" marginTop="5px">
              Invalid code entered 3 times. Your Vault is now locked.
              <p>Please contact&nbsp;<Link href="https://share.hsforms.com/1n5-LEIiqTUyScicS-czMBAcdn4z" rel="noreferrer"
                target="_blank"
                fontWeight="bold"
                color="#D14343 !important"
                textDecoration="underline"
                sx={{ textDecorationColor: '#D14343 !important' }}>customer support</Link>&nbsp;for help.</p>
              </Box>
              </Alert>
            }

        </div>
      </Box>
    </MainLayout>
  )
}

export default VaultVerification
